import { useEffect, useState } from 'react';
import CustomModal from '@/components/common/elements/Modal';
import Container from '@/components/common/elements/Container';
import Text from '@/components/common/elements/Text';
import Button from '@/components/common/elements/Button';
import { useIsMobile } from '@/common/hooks';
import { designSystem } from '@/styles/theme';
import {
    PostWriteLimit,
    describeLimitRule,
    formatBlockedUntil,
    formatRemaining,
    remainingSecondsFrom,
} from '@/common/postWriteLimit';

interface WriteLimitModalProps {
    open: boolean;
    limit: PostWriteLimit | null;
    onClose: () => void;
}

/**
 * 글쓰기 제한(도배 방지) 안내 모달 — 제한 사유와 남은 시간·해제 시각을 보여준다.
 * 열려 있는 동안 1분마다 남은 시간을 다시 계산한다.
 */
const WriteLimitModal = ({ open, limit, onClose }: WriteLimitModalProps) => {
    const isMobile: boolean = useIsMobile();
    const [remaining, setRemaining] = useState<number>(0);

    useEffect(() => {
        if (!open || !limit) {
            return;
        }
        setRemaining(remainingSecondsFrom(limit));
        const timer = window.setInterval(() => {
            setRemaining(remainingSecondsFrom(limit));
        }, 60_000);
        return () => window.clearInterval(timer);
    }, [open, limit]);

    if (!limit) {
        return null;
    }

    const until: string = formatBlockedUntil(limit.blockedUntil);

    return (
        <CustomModal
            title='글쓰기가 잠시 제한됐어요'
            width={isMobile ? '90%' : '450px'}
            onClose={onClose}
            open={open}
            height='auto'
        >
            <Container width={'100%'} display='block'>
                <Text textalign='center' size='15px' style={{ display: 'block', lineHeight: 1.6, color: '#555' }}>
                    {describeLimitRule(limit)}
                </Text>
                <div
                    style={{
                        margin: '16px 0',
                        padding: '16px',
                        borderRadius: '12px',
                        background: '#F3F7F5',
                        textAlign: 'center',
                    }}
                >
                    <Text size='14px' style={{ display: 'block', color: '#3D7E79', fontWeight: 700 }}>
                        남은 시간
                    </Text>
                    <Text size='22px' style={{ display: 'block', fontWeight: 800, marginTop: '4px' }}>
                        {formatRemaining(remaining)}
                    </Text>
                    {until && (
                        <Text size='13px' style={{ display: 'block', color: '#6B7A77', marginTop: '6px' }}>
                            {until} 이후 다시 작성할 수 있어요.
                        </Text>
                    )}
                </div>
                <Button
                    onClick={onClose}
                    justifycontents='center'
                    color='#fff'
                    bgcolor={designSystem.colors.primary}
                >
                    확인
                </Button>
            </Container>
        </CustomModal>
    );
};

export default WriteLimitModal;
